export class SignUpModel {
    confirmPassword: string;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
}